import React, { useState, useContext, useEffect } from 'react';
import { Form, Button, Card, Container, Row, Col } from 'react-bootstrap';
import api from './AxiosConfig'; 
import { AuthContext }              from './AuthContext';
import { useNavigate }              from 'react-router-dom';
import GoalTypesInfo                from './GoalTypesInfo';
import { BsFillInfoCircleFill } from "react-icons/bs";

function AddGoal() {
  const { isLoggedIn, checkSession } = useContext(AuthContext);
  const navigate = useNavigate();
  const [selectedOption,  setSelectedOption]  = useState('');
  const [masterGoals,     setMasterGoals]     = useState();
  const [goalInfoDisplay, setGoalInfoDisplay] = useState( false );
  const [newGoalsAllowed, setNewGoalsAllowed] = useState( true );

  // State to manage form data
  const [formData, setFormData] = useState({});
  // Status Message
  const [message, setMessage] = useState('');
  const goalTypes = [ { _id: 0, name: 'Choose one...'},
                      { _id: 1, name: 'MasterGoal'},
                      { _id: 2, name: 'DailyCheck'}, 
                      { _id: 3, name: 'DailyQuantityTarget'},
                      { _id: 4, name: 'DailyXInYAtLeast'},
                      { _id: 5, name: 'DailyXInYLessThan'},
                      { _id: 6, name: 'CheckList' },
                      { _id: 7, name: 'CountDown' },
                      { _id: 8, name: 'RadarMap'  },
                    ];

  useEffect(() => {
     const callCheckSession = async () => {
         try {
             await checkSession();
         } catch (error) {
             console.log("Error calling checkSession." + error.message);
         }
    }

    callCheckSession();
    
  });

  useEffect( () => {
      const checkGoalLimitValid = async () => {
          try {
              const response = await api.get('/site/goals/check-limit', { withCredentials: true });
              setNewGoalsAllowed( response.data.success);
          } catch (error) {
              console.log("checkGoalLimitValid: " + error );
          }
      }
      checkGoalLimitValid();
  }, []);

  useEffect( () => {
      const fetchMasterGoals = async () => {
          try {
              if ( !masterGoals ) {
                 const response = await api.get('/site/goals/master', { withCredentials: true });
                 const mg = []
                 mg.push({id: 0, goal_title: "Not Allocated"});
                 for ( let i=0; i < response.data.length ; i++ ) {
                     mg.push( response.data[i] );
                 }
                 setMasterGoals( mg );
              }
          } catch (error) {
              console.log("fetchMasterGoals: " + error );
          }
      }
      fetchMasterGoals();
  }, [masterGoals]);
  
  // Handle select option change
  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    setFormData({ 'goalType' : event.target.value}); // Reset form data when the option changes
  };

  // Handle input change
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const toggleInfo = () => {
     setGoalInfoDisplay(!goalInfoDisplay);
  }
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await api.put('/site/goals', formData, { withCredentials: true });
      navigate('/status', {});
    } catch (error) {
      if (error.response) {
        setMessage(error.response.data.message);  // Display error message from server
      } else {
        setMessage('An error occurred while signing up');
      }
    }
  };
  
  // Render different form fields based on the selected option
  const renderFields = () => {
    switch (selectedOption) {
      case 'DailyQuantityTarget':
        return (
          <>
            <Form.Group controlId="formTitle">
                <Form.Label>Goal Name</Form.Label>
                <Form.Control type="text" name="goalTitle" value={formData.goalTitle} onChange={handleInputChange} placeholder="Goal Title" />
            </Form.Group>
            <Form.Group controlId="formDescription">
                <Form.Label>Goal Description</Form.Label>
                <Form.Control type="text" name="goalDescription" value={formData.goalDescription} onChange={handleInputChange} placeholder="Goal Description" />
            </Form.Group>
            <Form.Group controlId="formTargetDate">
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" name="targetDate" value={formData.targetDate} onChange={handleInputChange} placeholder="Target Date" />
            </Form.Group>
            <Form.Group controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} placeholder="Start Date" />
            </Form.Group>
            <Form.Group controlId="formStartValue">
                <Form.Label>Start Value</Form.Label>
                <Form.Control type="text" name="startValue" value={formData.startValue} onChange={handleInputChange} placeholder="Start Value" />
            </Form.Group>
            <Form.Group controlId="formTargetValue">
                <Form.Label>Target Value</Form.Label>
                <Form.Control type="text" name="targetValue" value={formData.targetValue} onChange={handleInputChange} placeholder="Target Value" />
            </Form.Group>
            <Form.Group controlId="formUnits">
                <Form.Label>Units</Form.Label>
                <Form.Control type="text" name="dqt_units" value={formData.dqt_units} onChange={handleInputChange} placeholder="units" />
            </Form.Group>
            <Form.Group controlId="formSamplePeriod">
                <Form.Label>Sample Period</Form.Label>
                <Form.Control type="text" name="samplePeriod" value={formData.samplePeriod} onChange={handleInputChange} placeholder="Sample Period" />
            </Form.Group>
            <Form.Group controlId="formMasterRef">
                <Form.Label>Master Goal</Form.Label>
                    <select name="master_ref" value={formData.master_ref} onChange={handleInputChange}>
                    {masterGoals.map((item, index) => (
                        <option key={item.id} value={item.id}>
                        {item.goal_title}
                        </option>
               ))}          
             </select>
            </Form.Group>
          </>
        );
      case 'DailyCheck':
        return (
          <>
            <Form.Group controlId="formTitle">
                <Form.Label>Goal Name</Form.Label>
                <Form.Control type="text" name="goalTitle" value={formData.goalTitle} onChange={handleInputChange} placeholder="Goal Title" />
            </Form.Group>
            <Form.Group controlId="formDescription">
                <Form.Label>Goal Description</Form.Label>
                <Form.Control type="text" name="goalDescription" value={formData.goalDescription} onChange={handleInputChange} placeholder="Goal Description" />
            </Form.Group>
            <Form.Group controlId="formTargetDate">
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" name="targetDate" value={formData.targetDate} onChange={handleInputChange} placeholder="Target Date" />
            </Form.Group>
            <Form.Group controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} placeholder="Start Date" />
            </Form.Group>
            <Form.Group controlId="formSamplePeriod">
                <Form.Label>Sample Period</Form.Label>
                <Form.Control type="text" name="samplePeriod" value={formData.samplePeriod} onChange={handleInputChange} placeholder="Sample Period" />
            </Form.Group>
            <Form.Group controlId="formMasterRef">
                <Form.Label>Master Goal</Form.Label>
                    <select name="master_ref" value={formData.master_ref} onChange={handleInputChange}>
                    {masterGoals.map((item, index) => (
                        <option key={item.id} value={item.id}>
                        {item.goal_title}
                        </option>
               ))}          
             </select>
            </Form.Group>
          </>
        );

      case 'DailyXInYAtLeast':
        return(
          <>
            <Form.Group controlId="formTitle">
                <Form.Label>Goal Name</Form.Label>
                <Form.Control type="text" name="goalTitle" value={formData.goalTitle} onChange={handleInputChange} placeholder="Goal Title" />
            </Form.Group>
            <Form.Group controlId="formDescription">
                <Form.Label>Goal Description</Form.Label>
                <Form.Control type="text" name="goalDescription" value={formData.goalDescription} onChange={handleInputChange} placeholder="Goal Description" />
            </Form.Group>
            <Form.Group controlId="formTargetDate">
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" name="targetDate" value={formData.targetDate} onChange={handleInputChange} placeholder="Target Date" />
            </Form.Group>
            <Form.Group controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} placeholder="Start Date" />
            </Form.Group>
            <Form.Group controlId="formSamplePeriod">
                <Form.Label>Sample Period</Form.Label>
                <Form.Control type="text" name="samplePeriod" value={formData.samplePeriod} onChange={handleInputChange} placeholder="Sample Period" />
            </Form.Group>
            <Form.Group controlId="formRequiredX">
                <Form.Label>Required X</Form.Label>
                <Form.Control type="text" name="requiredX" value={formData.requiredX} onChange={handleInputChange} placeholder="Required X" />
            </Form.Group>
            <Form.Group controlId="formPeriodY">
                <Form.Label>In Period Y</Form.Label>
                <Form.Control type="text" name="inPeriodY" value={formData.inPeriodY} onChange={handleInputChange} placeholder="In Period Y" />
            </Form.Group>
            <Form.Group controlId="formMasterRef">
                <Form.Label>Master Goal</Form.Label>
                    <select name="master_ref" value={formData.master_ref} onChange={handleInputChange}>
                    {masterGoals.map((item, index) => (
                        <option key={item.id} value={item.id}>
                        {item.goal_title}
                        </option>
               ))}          
             </select>
            </Form.Group>
          </>
        );

    case 'DailyXInYLessThan':
        return(
          <>
            <Form.Group controlId="formTitle">
                <Form.Label>Goal Name</Form.Label>
                <Form.Control type="text" name="goalTitle" value={formData.goalTitle} onChange={handleInputChange} placeholder="Goal Title" />
            </Form.Group>
            <Form.Group controlId="formDescription">
                <Form.Label>Goal Description</Form.Label>
                <Form.Control type="text" name="goalDescription" value={formData.goalDescription} onChange={handleInputChange} placeholder="Goal Description" />
            </Form.Group>
            <Form.Group controlId="formTargetDate">
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" name="targetDate" value={formData.targetDate} onChange={handleInputChange} placeholder="Target Date" />
            </Form.Group>
            <Form.Group controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} placeholder="Start Date" />
            </Form.Group>
            <Form.Group controlId="formSamplePeriod">
                <Form.Label>Sample Period</Form.Label>
                <Form.Control type="text" name="samplePeriod" value={formData.samplePeriod} onChange={handleInputChange} placeholder="Sample Period" />
            </Form.Group>
            <Form.Group controlId="formRequiredX">
                <Form.Label>Required X</Form.Label>
                <Form.Control type="text" name="requiredX" value={formData.requiredX} onChange={handleInputChange} placeholder="Required X" />
            </Form.Group>
            <Form.Group controlId="formPeriodY">
                <Form.Label>In Period Y</Form.Label>
                <Form.Control type="text" name="inPeriodY" value={formData.inPeriodY} onChange={handleInputChange} placeholder="In Period Y" />
            </Form.Group>
            <Form.Group controlId="formMasterRef">
                <Form.Label>Master Goal</Form.Label>
                    <select name="master_ref" value={formData.master_ref} onChange={handleInputChange}>
                    {masterGoals.map((item, index) => (
                        <option key={item.id} value={item.id}>
                        {item.goal_title}
                        </option>
               ))}          
             </select>
            </Form.Group>
          </>
        );
      case 'MasterGoal':
        return(
          <>
            <Form.Group controlId="formTitle">
                <Form.Label>Goal Name</Form.Label>
                <Form.Control type="text" name="goalTitle" value={formData.goalTitle} onChange={handleInputChange} placeholder="Goal Title" />
            </Form.Group>
            <Form.Group controlId="formDescription">
                <Form.Label>Goal Description</Form.Label>
                <Form.Control type="text" name="goalDescription" value={formData.goalDescription} onChange={handleInputChange} placeholder="Goal Description" />
            </Form.Group>
            <Form.Group controlId="formTargetDate">
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" name="targetDate" value={formData.targetDate} onChange={handleInputChange} placeholder="Target Date" />
            </Form.Group>
            <Form.Group controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} placeholder="Start Date" />
            </Form.Group>
          </>
        );

      case 'CheckList':
        return(
          <>
            <Form.Group controlId="formTitle">
                <Form.Label>Goal Name</Form.Label>
                <Form.Control type="text" name="goalTitle" value={formData.goalTitle} onChange={handleInputChange} placeholder="Goal Title" />
            </Form.Group>
            <Form.Group controlId="formDescription">
                <Form.Label>Goal Summary</Form.Label>
                <Form.Control type="text" name="goalDescription" value={formData.goalDescription} onChange={handleInputChange} placeholder="Goal Description" />
            </Form.Group>
            <Form.Group controlId="formShortCode">
                <Form.Label>Short Code</Form.Label>
                <Form.Control type="text" name="shortcode" value={formData.shortcode} onChange={handleInputChange} placeholder="SC" />
            </Form.Group>
            <Form.Group controlId="formTargetDate">
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" name="targetDate" value={formData.targetDate} onChange={handleInputChange} placeholder="Target Date" />
            </Form.Group>
            <Form.Group controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} placeholder="Start Date" />
            </Form.Group>
            <Form.Group controlId="formMasterRef">
                <Form.Label>Master Goal</Form.Label>
                    <select name="master_ref" value={formData.master_ref} onChange={handleInputChange}>
                    {masterGoals.map((item, index) => (
                        <option key={item.id} value={item.id}>
                        {item.goal_title}
                        </option>
               ))}          
             </select>
            </Form.Group>
          </>
        );

      case 'CountDown':
        return (
          <>
            <Form.Group controlId="formTitle">
                <Form.Label>Goal Name</Form.Label>
                <Form.Control type="text" name="goalTitle" value={formData.goalTitle} onChange={handleInputChange} placeholder="Goal Title" />
            </Form.Group>
            <Form.Group controlId="formDescription">
                <Form.Label>Goal Description</Form.Label>
                <Form.Control type="text" name="goalDescription" value={formData.goalDescription} onChange={handleInputChange} placeholder="Goal Description" />
            </Form.Group>
            <Form.Group controlId="formTargetDate">
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" name="targetDate" value={formData.targetDate} onChange={handleInputChange} placeholder="Target Date" />
            </Form.Group>
            <Form.Group controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} placeholder="Start Date" />
            </Form.Group>
            <Form.Group controlId="formMasterRef">
                <Form.Label>Master Goal</Form.Label>
                    <select name="master_ref" value={formData.master_ref} onChange={handleInputChange}>
                    {masterGoals.map((item, index) => (
                        <option key={item.id} value={item.id}>
                        {item.goal_title}
                        </option>
               ))}          
             </select>
            </Form.Group>
          </>
        );

      case 'RadarMap':
        return (
          <>
            <Form.Group controlId="formTitle">
                <Form.Label>Goal Name</Form.Label>
                <Form.Control type="text" name="goalTitle" value={formData.goalTitle} onChange={handleInputChange} placeholder="Goal Title" />
            </Form.Group>
            <Form.Group controlId="formDescription">
                <Form.Label>Goal Description</Form.Label>
                <Form.Control type="text" name="goalDescription" value={formData.goalDescription} onChange={handleInputChange} placeholder="Goal Description" />
            </Form.Group>
            <Form.Group controlId="formTargetDate">
                <Form.Label>Target Date</Form.Label>
                <Form.Control type="date" name="targetDate" value={formData.targetDate} onChange={handleInputChange} placeholder="Target Date" />
            </Form.Group>
            <Form.Group controlId="formStartDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control type="date" name="startDate" value={formData.startDate} onChange={handleInputChange} placeholder="Start Date" />
            </Form.Group>
            <Form.Group controlId="formMasterRef">
                <Form.Label>Master Goal</Form.Label>
                    <select name="master_ref" value={formData.master_ref} onChange={handleInputChange}>
                    {masterGoals.map((item, index) => (
                        <option key={item.id} value={item.id}>
                        {item.goal_title}
                        </option>
               ))}          
             </select>
            </Form.Group>
          </>
        );


      default:
        return null;
    }
  };

 if (isLoggedIn === null) {
    // Still checking session
    return <div>Loading...</div>;
  } else if (isLoggedIn === false ){
      // Navigate to login page...
      navigate('/login', { state: { from: 'Status' } });     
  } else if ( !newGoalsAllowed) {
      return( <Container>
        <Row className="justify-content-md-center">
          <Col>
            <Card className={'mb-1 mt-2 card-system-message'}>
              <Card.Body className={' content-container'}>
                <div className="left-content d-flex align-items-center flex-grow-1">Free User maximum goal limit reached.</div>
                <div className="right-content">&nbsp;</div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container> );
  } else { 
      // isLoggedIn === true && newGoalsAllowed === true
     return (
         <Container className="mt-2">
             <Row className="justify-content-md-center">
               <Col md="6">
                 <Card>
                 <Card.Header>
                 Create New Goal <BsFillInfoCircleFill onClick={toggleInfo}/>
                 </Card.Header>
                 <Card.Body>
                 { goalInfoDisplay && ( <><GoalTypesInfo /><div>&nbsp;</div></> )}
                  <form onSubmit={handleSubmit}>
                     <Card.Text>Choose a Goal Type:</Card.Text>
                     <Card.Text><select value={selectedOption} onChange={handleSelectChange}>
             {goalTypes.map((option) => (
               <option key={option._id} value={option.name}>
                 {option.name}
               </option>
               ))}          
             </select>
             </Card.Text>
        
               {renderFields()}

        <Card.Text><Button variant="primary" type="submit">Create Goal</Button></Card.Text>
          </form>
          </Card.Body>
      <Card.Footer>{message}</Card.Footer>       
      </Card>
      </Col>
      </Row>
    </Container>
  );
  }
}

export default AddGoal;
